import React from "react";
import "./ReInvoicingMapping.css";

const splitValues = (value) =>
    String(value || "")
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);

const MappingNode = ({ label, value }) => (
    <div className="rim-node">
        <span className="rim-node__label">{label}</span>
        <span className="rim-node__value">{value}</span>
    </div>
);

/**
 * Visualizes the TI -> PI mapping for re-invoicing requests.
 * TI always appears on the left; PI on the right. The side with
 * multiple comma-separated numbers is shown as branches.
 */
const ReInvoicingMapping = ({ piNo, tiNo }) => {
    const piList = splitValues(piNo);
    const tiList = splitValues(tiNo);

    if (piList.length === 0 || tiList.length === 0) {
        return null;
    }

    const tiIsMultiple = tiList.length > 1;
    const piIsMultiple = piList.length > 1;

    // Defensive fallback if both sides ever come back with multiple values.
    if (tiIsMultiple && piIsMultiple) {
        return (
            <div className="rim-fallback">
                <div className="rim-fallback__col">
                    {tiList.map((value) => (
                        <MappingNode key={value} label="TI No" value={value} />
                    ))}
                </div>
                <div className="rim-fallback__col">
                    {piList.map((value) => (
                        <MappingNode key={value} label="PI No" value={value} />
                    ))}
                </div>
            </div>
        );
    }

    const summaryMultipleLabel = tiIsMultiple ? "TI No" : "PI No";
    const summaryMultipleCount = tiIsMultiple ? tiList.length : piList.length;
    const summarySingleLabel = tiIsMultiple ? "PI No" : "TI No";
    const summarySingleValue = tiIsMultiple ? piList[0] : tiList[0];

    return (
        <div className="rim">
            <div className="rim__summary">
                {summaryMultipleCount} {summaryMultipleLabel}
                {summaryMultipleCount > 1 ? "s are" : " is"} mapped to 1 {summarySingleLabel} (
                {summarySingleValue})
            </div>
            <div className={`rim__flow${tiIsMultiple ? " rim__flow--reversed" : ""}`}>
                {tiIsMultiple ? (
                    <>
                        <div className="rim__branches rim__branches--left">
                            {tiList.map((value) => (
                                <div className="rim__branch" key={value}>
                                    <MappingNode label="TI No" value={value} />
                                </div>
                            ))}
                        </div>
                        <div className="rim__source rim__source--right">
                            <MappingNode label="PI No" value={piList[0]} />
                        </div>
                    </>
                ) : (
                    <>
                        <div className="rim__source">
                            <MappingNode label="TI No" value={tiList[0]} />
                        </div>
                        <div className="rim__branches">
                            {piList.map((value) => (
                                <div className="rim__branch" key={value}>
                                    <MappingNode label="PI No" value={value} />
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default ReInvoicingMapping;
